import { Button } from "@humansignal/ui";
import { modal } from "../../components/Modal/Modal";
import { useModalControls } from "../../components/Modal/ModalPopup";
import { Space } from "../../components/Space/Space";
import { cn } from "../../utils/bem";
import { useTranslation } from "../../i18n/LocaleProvider";

export const WebhookDeleteModal = ({ onDelete }) => {
  return modal({
    title: "Delete",
    body: () => {
      const rootClass = cn("webhook-delete-modal");
      return (
        <div className={rootClass}>
          <div className={rootClass.elem("modal-text").toClassName()}>
            Are you sure you want to delete the webhook? This action cannot be undone.
          </div>
        </div>
      );
    },
    footer: () => {
      const { t } = useTranslation();
      const ctrl = useModalControls();
      return (
        <Space align="end">
          <Button
            look="outlined"
            onClick={() => {
              ctrl.hide();
            }}
            aria-label={t("pages.webhookpage.webhook_delete_modal.cancel_webhook_deletion")}
          >
            Cancel
          </Button>
          <Button
            variant="negative"
            onClick={async () => {
              await onDelete();
              ctrl.hide();
            }}
            aria-label={t("pages.webhookpage.webhook_delete_modal.confirm_webhook_deletion")}
          >
            Delete Webhook
          </Button>
        </Space>
      );
    },
    style: { width: 512 },
  });
};
